import { css } from 'styled-components'
import { styleAnchor, styleBlockquote, styleList, stylePre } from './Style'
import {
  typoBlockquote,
  typoCode,
  typoHeading2,
  typoHeading3,
  typoHeading4,
  typoHeading5,
  typoHeading6,
  typoParagraph,
  typoParagraphS,
} from './Typography'
import { StyledButton } from '../../components/UI/Button/styled'

export const Prose = css`
  .prose {
    //////////////////////////////////
    // markResolvers
    //////////////////////////////////

    // MARK_LINK
    a.is-prose {
      ${styleAnchor}

      &${StyledButton} {
        text-decoration: none;
      }
    }

    //////////////////////////////////
    // nodeResolvers
    //////////////////////////////////

    // NODE_HEADING
    h1.is-prose {
      ${typoHeading2};
      margin-top: 5rem;
      margin-bottom: 1.5rem;
    }

    h2.is-prose {
      ${typoHeading3};
      margin-top: 5rem;
      margin-bottom: 1.5rem;
    }

    h3.is-prose {
      ${typoHeading4};
      margin-top: 3rem;
      margin-bottom: 1rem;
    }

    h4.is-prose {
      ${typoHeading4};
      margin-top: 3rem;
      margin-bottom: 1rem;
    }

    h5.is-prose {
      ${typoHeading5};
      margin-top: 3rem;
      margin-bottom: 1rem;
    }

    h6.is-prose {
      ${typoHeading6};
      margin-top: 3rem;
      margin-bottom: 1rem;
    }

    // NODE_CODEBLOCK
    pre.is-prose {
      ${stylePre};
      margin-block: 3rem;

      code {
        ${typoCode};
      }

      &:has(+ pre) {
        margin-bottom: -2rem;
      }
    }

    // NODE_IMAGE
    figure.is-prose,
    [role='figure'].is-prose {
      display: block;
      margin-top: 3rem;
      margin-bottom: 3rem;

      figcaption,
      [role='figurecaption'] {
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        ${typoParagraphS};
        color: ${({ theme }) => theme.colors.black[3]};
      }

      figurecaption > span,
      [role='figurecaption'] > span {
        display: block;
        text-align: center;
        margin-top: 0.2rem;
        font-size: 0.7rem;
        line-height: 1.1;
        color: ${({ theme }) => theme.colors.black[4]};
      }
    }

    // NODE_PARAGRAPH
    p.is-prose {
      ${typoParagraph};
    }

    // NODE_QUOTE
    blockquote.is-prose {
      ${typoBlockquote}
      ${styleBlockquote}
      margin-top: 3rem;
      margin-bottom: 3rem;
    }

    // NODE_OL
    // NODE_UL
    ol.is-prose,
    ul.is-prose {
      ${styleList};
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    // NODE_LI
    li.is-prose {

      &::marker {
        list-style-type: none;
        content: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.6%206.20006C19.0418%206.53143%2019.1314%207.15823%2018.8%207.60006L11.3%2017.6001C11.1314%2017.8249%2010.876%2017.9683%2010.5963%2017.9954C10.3166%2018.0225%2010.0385%2017.9306%209.82991%2017.7423L5.32991%2013.6798C4.91996%2013.3097%204.88765%2012.6774%205.25774%2012.2675C5.62783%2011.8575%206.26017%2011.8252%206.67011%2012.1953L10.3572%2015.5239L17.2%206.40006C17.5314%205.95823%2018.1582%205.86869%2018.6%206.20006Z%22%20fill%3D%22%230D0D0D%22%2F%3E%0A%3C%2Fsvg%3E");
        width: 20px; /* Set the width of the SVG image */
        height: 20px; /* Set the height of the SVG image */
        margin-right: 10px;
      }

      > ul,
      > ol {
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    //////////////////////////////////
    // Other rules
    //////////////////////////////////

    & > :first-child,
    & > :first-child figure,
    & > :first-child [role='figure'] {
      margin-top: 0;
    }

    & > :last-child,
    & > :last-child figure,
    & > :last-child [role='figure'] {
      margin-bottom: 0;
    }
  }
`
